module.exports = __webpack_public_path__ + "img/2ef139de7f2e95fcd2dcd879eb9d3ce.fe8f495d.png";